export default __webpack_public_path__ + "static/button-decorative-icon-e069747a08309c42264da7f8c99f6129.png";